import { Component, Inject, OnInit, ViewChild } from "@angular/core";
import { UntypedFormControl, UntypedFormGroup } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";

import { SharedService } from "@shared/services/shared.service";

import { AdminService } from "app/services/admin/admin.service";
import { ComplaintService } from "app/services/complaint/complaint.service";

@Component({
  selector: 'complaint-addComplaintFile',
  templateUrl: './addComplaintFile.component.html',
  styleUrls: ['./addComplaintFile.component.scss']
})

export class AddComplaintFilesComponent implements OnInit {

  file: File;
  fileName: string = '';
  complaintId: string = '';

  form = new UntypedFormGroup({
    name: new UntypedFormControl(''),
    description: new UntypedFormControl('')
  });

  constructor(
    private sharedService: SharedService,
    private complaintService: ComplaintService,
    private dialogRef: MatDialogRef<AddComplaintFilesComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.complaintId = data.complaintId;
  }

  ngOnInit(): void {
  }

  uploadFile(event): void {
    this.file = event.target.files[0];
    this.fileName = this.file.name;
  }

  close() {
    this.dialogRef.close('none');
  }

  addFile() {
    if (this.file != null) {
      let formData = new FormData();
      formData.append('name', this.form.controls['name'].value);
      formData.append('complaintId', this.complaintId);
      formData.append('description', this.form.controls['description'].value);
      formData.append('fileToUpload', this.file, this.file.name);

      this.complaintService.addComplaintFile(formData).subscribe(
        (result) => {
          this.complaintService.complaintTab = 1;

          // this.sharedService.doRedirect('complaint/complaint/' + this.complaintId);
          this.sharedService.toastr.success("File Saved Successfully");
          this.dialogRef.close('refresh');
        },
        error => {
          this.sharedService.toastr.error("Could not save file: " + error.message);
        }
      );
    }
    else {
      this.sharedService.toastr.error("No file selected");
    }
  }

}